import { useParameter } from '../../../shared';

export function useDescription() {
  const description = [
    'Showing long-term development of Fertilizer Prices',
    'Source: USDA AL, USDA IA, World Bank'
  ];
  return description;
}